import { h, FunctionComponent } from 'preact'
import { useEffect, useRef } from 'preact/hooks'

type Props = {
  onHeight: (height: number) => void
}

const ElementHeightGetter: FunctionComponent<Props> = ({ children, onHeight }) => {
  const domRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    onHeight(domRef.current?.offsetHeight ?? 0)
  })
  return <div ref={domRef}>{children}</div>
}

export default ElementHeightGetter
